<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="container">
    <div class="title">
        <h4>Listado de Productos</h4>
        <button type="button" class="btn btn-primary" routerLink="/add">Agregar Producto</button>
    </div>

    <table *ngIf="listProducts.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Descripcion</th>
            <th scope="col">Precio</th>
            <th scope="col">Stock</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listProducts" class="table-active">
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.price | currency }}</td>
            <td>{{ item.stock }}</td>
            <td>
                <button routerLink="/edit/{{ item.id }}" type="button" class="btn btn-info btn-sm">Edit</button>
                <button (click)="deleteProduct(item.id!)" type="button" class="btn btn-secondary btn-sm ms-2">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 *ngIf="listProducts.length == 0">No hay productos para mostrar</h5>
</div>
